/* eslint-disable no-lonely-if */
import React from 'react';
import './css/DestinationInputValue.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeAvailableDays } from '../../../../DataStore/actions/searchFormActions';
import { getShortString } from '../../../../Utils/CommonUtils';

const mapStateToProps = (state) => ({ ...state });

class DestinationInputValue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  calculateInputValue = () => {
    let result;
    const { destination, selectedResorts, hotelsFilter } = this.props;

    if (hotelsFilter.length > 0) {
      if (hotelsFilter.length === 1) {
        if (hotelsFilter[0].name.length > 90) {
          result = hotelsFilter[0].name.substring(0, 90);
          result += '...';
        } else {
          result = hotelsFilter[0].name;
        }
      } else if (hotelsFilter.length < 5) {
        result = `${hotelsFilter.length} отеля`;
      } else {
        result = `${hotelsFilter.length} отелей`;
      }
    } else {
      if (selectedResorts.length === 0) {
        result = destination.name;
      } else if (selectedResorts.length === 1) {
        result = `${selectedResorts[0].name}, ${destination.name}`;
      } else if (selectedResorts.length < 5) {
        result = `${selectedResorts.length} курорта, ${destination.name}`;
      } else if (selectedResorts.length >= 5) {
        result = `${selectedResorts.length} курортов, ${destination.name}`;
      }
    }

    return getShortString(result, 20);
  };

  render() {
    // sf_destination_text - class for destination popup close skipping
    return (
      <div className="sf_destination_text">{this.calculateInputValue()}</div>
    );
  }
}

DestinationInputValue.propTypes = {
  destination: PropTypes.instanceOf(Object).isRequired,
  selectedResorts: PropTypes.instanceOf(Array).isRequired,
  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
};

export default connect(mapStateToProps, { changeAvailableDays })(
  DestinationInputValue,
);
